import './Navbar.css';
import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logopng from "../../assets/logo.webp";
import AuthContext from './AuthContext';
import { FaUserCircle, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import NotificationDropdown from '../common/NotificationDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications } from '../../actions/NotificationActions';

export default function Navbar() {
    const { isAuthenticated, logout } = useContext(AuthContext);
    const location = useLocation();
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [visible, setVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const navbarRef = useRef(null);
    const userMenuRef = useRef(null);
    const toggleRef = useRef(null);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const allNotifications = useSelector(state => state.notifications.allNotifications);

    const toggleNotifications = () => {
        setIsNotificationOpen(!isNotificationOpen);
    };
    const unreadCount = Array.isArray(allNotifications)? allNotifications.filter(n => !n.isRead).length: 0;
    const userRole = localStorage.getItem('userRole') || 'student'; // Default to 'student' if not set
    const handleLogout = () => {
        logout();
        setIsNavbarOpen(false);
        setIsUserMenuOpen(false);
    };

    const toggleNavbar = (e) => {
        e.stopPropagation();
        setIsNavbarOpen(prev => !prev);
    };

    const closeNavbar = () => setIsNavbarOpen(false);
    const toggleUserMenu = () => setIsUserMenuOpen(!isUserMenuOpen);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isAuthenticated) {  // Only fetch if authenticated
            dispatch(fetchNotifications());
        }
    }, [dispatch, isAuthenticated]);  // Add isAuthenticated as dependency

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setVisible(false);
            } else if (currentScrollY < lastScrollY) {
                setVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target) &&
                (!toggleRef.current || !toggleRef.current.contains(event.target))) {
                setIsNavbarOpen(false);
            }
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setIsUserMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        closeNavbar();
    }, [location.pathname]);

    return (
        <nav className={`mmexams-navbar navbar navbar-expand-lg ${visible ? 'mmexams-navbar-visible' : 'mmexams-navbar-hidden'}`} ref={navbarRef}>
            <div className="mmexams-navbar-container container-fluid">
                <Link className="mmexams-navbar-brand navbar-brand" to="/" onClick={closeNavbar}>
                    <img src={logopng} alt="Make My Exam" className='mmexams-navbar-logo' />
                    <div className="mmexams-navbar-brandtext">
                        <strong className='mmexams-navbar-brandtitle'>My Exam World</strong>
                        <span className='mmexams-navbar-brandsubtitle'>Test Series | Live Exam</span>
                    </div>
                </Link>

                {/* Mobile Notification Icon - shown only on mobile */}
                <div className="d-flex align-items-center ms-auto">
                    {isAuthenticated && (
                        <div className="d-lg-none mmexams-mobile-notification-icon">
                            <NotificationDropdown
                                notifications={allNotifications}
                                unreadCount={unreadCount}
                                isOpen={isNotificationOpen}
                                toggle={toggleNotifications}
                                onClose={() => setIsNotificationOpen(false)}
                            />
                        </div>
                    )}

                    <button
                        ref={toggleRef}
                        className="mmexams-navbar-toggler navbar-toggler"
                        onClick={toggleNavbar}
                        aria-label="Toggle navigation"
                        aria-expanded={isNavbarOpen}
                    >
                        {isNavbarOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>
                <div className={`mmexams-navbar-collapse collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`}>
                    <ul className="mmexams-navbar-nav navbar-nav me-auto">
                        <li className="mmexams-nav-item nav-item">
                            <Link className="mmexams-nav-link nav-link" to="/" onClick={closeNavbar}>Home</Link>
                        </li>
                        {userRole === 'creator' ? ("") :
                            <>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/alltest" onClick={closeNavbar}>All Tests</Link>
                                </li>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/allcreators" onClick={closeNavbar}>Top Creators</Link>
                                </li>
                            </>
                        }
                        {/* <li className="mmexams-nav-item nav-item">
                            <Link className="mmexams-nav-link nav-link" to="/aboutus" onClick={closeNavbar}>About Us</Link>
                        </li> */}

                        {isAuthenticated && userRole === 'creator' && (
                            <>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/create-test" onClick={closeNavbar}>
                                        Create Test
                                    </Link>
                                </li>
                                 <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/create-test-with-excel" onClick={closeNavbar}>
                                        Create Test with Excel
                                    </Link>
                                </li>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/my-created-test" onClick={closeNavbar}>
                                        My Created Tests
                                    </Link>
                                </li>
                            </>
                        )}

                        {isAuthenticated && userRole === 'student' && (
                            <>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/my-performance" onClick={closeNavbar}>My Performance</Link>
                                </li>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/my-subcriptions" onClick={closeNavbar}>My Subcriptions</Link>
                                </li>
                            </>

                        )}

                        {isAuthenticated ? (
                            <>
                                <li className="mmexams-nav-item nav-item d-lg-none">
                                    <Link className="mmexams-nav-link nav-link"
                                        to={userRole === 'creator' ? '/creator-profile' : '/student-profile'} // Dynamically set the route
                                        onClick={closeNavbar}>
                                        Profile
                                    </Link>
                                </li>
                                <li className="mmexams-nav-item nav-item d-lg-none">
                                    <button className="mmexams-nav-link nav-link mmexams-nav-logout" onClick={handleLogout}>
                                        <FaSignOutAlt className="mmexams-nav-icon" /> Logout
                                    </button>
                                </li>
                            </>
                        ) : (
                            <div className="d-lg-none mmexams-authbuttons-mobile">
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/signin" onClick={closeNavbar}>
                                        Sign In
                                    </Link>
                                </li>
                                <li className="mmexams-nav-item nav-item">
                                    <Link className="mmexams-nav-link nav-link" to="/signup" onClick={closeNavbar}>
                                        Sign Up
                                    </Link>
                                </li>
                            </div>
                        )}
                    </ul>

                    <div className="mmexams-navbar-usercontrols d-none d-lg-flex align-items-center">
                        {isAuthenticated && (
                            <NotificationDropdown
                                notifications={allNotifications}
                                unreadCount={unreadCount}
                                isOpen={isNotificationOpen}
                                toggle={toggleNotifications}
                                onClose={() => setIsNotificationOpen(false)}
                            />
                        )}
                        {isAuthenticated ? (
                            <div className="mmexams-usermenu" ref={userMenuRef}>
                                <button
                                    className="mmexams-usermenu-toggle"
                                    onClick={toggleUserMenu}
                                    aria-label="User menu"
                                >
                                    <FaUserCircle className="mmexams-usermenu-icon" />
                                </button>

                                {isUserMenuOpen && (
                                    <div className="mmexams-usermenu-dropdown">
                                        <Link
                                            className="mmexams-usermenu-item"
                                            to={userRole === 'creator' ? '/creator-profile' : '/student-profile'} // Dynamically set the route
                                            onClick={() => {
                                                closeNavbar();
                                                setIsUserMenuOpen(false);
                                            }}
                                        >
                                            Profile
                                        </Link>
                                        <button
                                            className="mmexams-usermenu-logout"
                                            onClick={handleLogout}
                                        >
                                            <FaSignOutAlt className="mmexams-usermenu-icon" /> Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="mmexams-authbuttons">
                                <Link
                                    className="mmexams-authbutton-signin"
                                    to="/signin"
                                    onClick={closeNavbar}
                                >
                                    Sign In
                                </Link>
                                <Link
                                    className="mmexams-authbutton-signup"
                                    to="/signup"
                                    onClick={closeNavbar}
                                >
                                    Sign Up
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}
